import { useEffect, useState } from "react";
import { Mail, Phone } from "lucide-react";
import { authApi } from "@/api";

export default function AdminEnquiries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authApi.get("/admin/enquiries").then(({ data }) => { setItems(data); setLoading(false); });
  }, []);

  return (
    <div data-testid="admin-enquiries-page">
      <h1 className="heading-2 mb-2">Enquiries</h1>
      <p className="text-muted-foreground text-sm mb-8">{items.length} enquiries</p>

      {loading ? (
        <div className="p-10 text-center text-muted-foreground">Loading…</div>
      ) : items.length === 0 ? (
        <div className="bg-white border border-border p-10 text-center text-muted-foreground">No enquiries yet.</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {items.map((e) => (
            <div key={e.id} className="bg-white border border-border p-5" data-testid={`enquiry-${e.id.slice(0, 8)}`}>
              <div className="flex items-center justify-between">
                <span className="label-caps text-[#E31837]">{e.subject}</span>
                <span className="text-xs text-muted-foreground">{new Date(e.created_at).toLocaleDateString("en-IN")}</span>
              </div>
              <p className="font-head text-lg font-bold uppercase tracking-tight mt-2">{e.name}</p>
              <div className="flex flex-wrap gap-4 mt-1 text-sm text-muted-foreground">
                <a href={`mailto:${e.email}`} className="flex items-center gap-1 hover:text-[#E31837]"><Mail className="h-3.5 w-3.5" /> {e.email}</a>
                {e.phone && <span className="flex items-center gap-1"><Phone className="h-3.5 w-3.5" /> {e.phone}</span>}
              </div>
              <p className="mt-3 text-sm leading-relaxed border-t border-border pt-3">{e.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
